import { render, staticRenderFns } from "./FixOrderRecoverItemCard.vue?vue&type=template&id=6bb5e4a6&scoped=true&"
import script from "./FixOrderRecoverItemCard.vue?vue&type=script&lang=ts&"
export * from "./FixOrderRecoverItemCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb5e4a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
